import {
    LegalDocumentsData,
    LegalDocsConfigurations,
    LegalDocumentsPackageData,
} from '@fiverr-private/legal_documents_package';
import { SellerEntityTypes } from '@fiverr-private/upmarket_common';

export interface TimeEstimation {
    min: number;
    max: number;
    amount: string;
}

export interface MonthlyCredit {
    value: number;
}

export enum RequestResults {
    CLEAR = 'clear',
    DISPUTE = 'dispute',
    CONSIDER = 'consider',
}

export enum ComplianceStatusRank {
    UNDEFINED,
    GREEN,
    BLUE,
    YELLLOW,
}

export enum Rank {
    COMPLIANT,
    IN_PROGRESS,
    CONSIDER,
    NOT_COMPLIANT,
}

export interface BackgroundCheckDataType {
    requesteeId: number;
    requesterId: number;
    updatedAt: string;
    externalVendorId: string;
    requestStatus: RequestStatuses;
    requestResults?: RequestResults;
}

export enum ClassificationRequestResults {
    INDEPENDENT_CONTRACTOR = 'independent_contractor', // Low risk
    EMPLOYEE = 'employee', // High risk
}

export interface WorkforceClassificationDataType {
    requesteeId: number;
    requesterId: number;
    updatedAt: string;
    requestStatus: WorkforceClassificationRequestStatuses;
    requestResults?: ClassificationRequestResults;
}

export interface ComplianceState {
    hasLegalDocsSetup?: boolean;
    legalDocsData?: LegalDocumentsData;
    backgroundCheckData: Record<number, BackgroundCheckDataType[]>;
    workforceClassificationData: Record<number, WorkforceClassificationDataType[]>;
}

export interface GetOrganizationComplianceDataResponse {
    hasLegalDocsSetup?: boolean;
    legalDocsData?: LegalDocumentsData;
    backgroundCheckData: Record<number, BackgroundCheckDataType[]>;
    workforceClassificationData: Record<number, WorkforceClassificationDataType[]>;
}

export interface BackgroundCheckPackageData {
    typeId: string;
    packageItemsIds?: string[];
    timeEstimation: TimeEstimation;
    monthlyCredit: MonthlyCredit;
    discountInPercents?: number;
    price: number;
    currency: string;
}

export interface FetchedBackgroundCheckPackageData {
    usTypeId: string;
    nonUsTypeId: string;
    timeEstimation: TimeEstimation;
    discountInPercents: number;
    usPrice: number;
    nonUsPrice: number;
    currency: string;
    monthlyCredit?: MonthlyCredit;
    packageItemsIds?: string[];
}

export interface BackgroundCheckData {
    canRequestBackgroundCheck: boolean;
    canDownloadBackgroundCheckFile: boolean;
    isEligibleForBackgroundCheck: boolean;
    existsBackgroundCheckdata: boolean;
    requestorUserName: string;
    isUs?: boolean;
}

export interface GeneralConfigs {
    sellerEntityType: SellerEntityTypes;
}

export interface ConfigResponse {
    backgroundCheckData: BackgroundCheckData;
    legalDocsData: LegalDocsConfigurations;
    workforceClassificationData: WorkforceClassificationConfigurations;
    generalConfigs: GeneralConfigs;
}

export interface OrganizationPackagesData {
    backgroundCheckPackageData: BackgroundCheckPackageData;
    workforceClassificationPackageData: PackageData;
    legalDocsPackageData: LegalDocumentsPackageData;
}

export interface FetchedOrganizationPackagesData {
    backgroundCheckPackageData: FetchedBackgroundCheckPackageData;
    workforceClassificationPackageData: PackageData;
    legalDocsPackageData: LegalDocumentsPackageData;
}

export enum RequestStatuses {
    REQUESTED = 'requested',
    INITIATED = 'initiated',
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    FAILED = 'failed',
    EXPIRED = 'expired',
}

export enum WorkforceClassificationRequestStatuses {
    REQUESTED = 'requested',
    IN_PROGRESS = 'inProgress',
    COMPLETED = 'completed',
    CANCELED = 'canceled',
    REJECTED = 'rejected',
    EXPIRED = 'expired',
}

export interface PackageData {
    typeId: string;
    timeEstimation: TimeEstimation;
    price: number;
    discountInPercents: number;
    priceToPay: number;
    currency: string;
    packageItemsIds: string[];
    monthlyCredit?: MonthlyCredit;
}

export interface WorkforceClassificationConfigurations {
    canRequestWorkforceClassification: boolean;
    existsWorkforceClassificationData: boolean;
    canDownloadWorkforceClassificationFile: boolean;
    requestorUserName: string;
}
